import { render, staticRenderFns } from "./ItsBaseFarmInspect.vue?vue&type=template&id=51be578e&scoped=true&"
import script from "./ItsBaseFarmInspect.vue?vue&type=script&lang=js&"
export * from "./ItsBaseFarmInspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be578e",
  null
  
)

export default component.exports